import LogoImg from '../../../assets/symbol_text.png'
import Caution from '../../../assets/ic_caution_filled.svg'
import Modu from '../../../assets/modu.png'
import { Button } from 'components/shared'
import { useNavigate } from 'react-router-dom'
export const Complete = () => {
    const navigator = useNavigate()
    return (
        <section className="flex h-screen justify-center py-5 items-center">
            <div className="flex flex-col max-w-[600px] min-w-[320px] w-full items-center gap-8">
                <article className="flex flex-col items-center">
                    <img src={LogoImg} className="w-[26%] aspect-auto" alt="" />
                    <h1 className="text-[clamp(22px,6vw,28px)] font-bold text-[#242424] text-center">
                        가입 신청을 축하드려요!
                        <br />
                        이제 계약서 서명만 남았어요.
                    </h1>
                </article>
                <article className="flex flex-col text-[clamp(14px,3vw,18px)] text-center break-keep gap-3 text-[#565656]">
                    <p>
                        대표자 휴대폰 번호로 입점 계약서가 발송되었어요.
                        <br />
                        계약서에 서명 후 입점 심사가 진행되며,
                        <br />
                        심사 결과는 영업일 기준 5일 이내 문자로 안내드립니다.
                    </p>
                    <p>
                        <img src={Caution} alt="" className="inline-block w-5 h-5 mb-1" />
                        &nbsp;
                        <span>
                            카카오톡 알림톡을 받지 못하셨거나, 휴대폰 번호 변경
                            <br />이 필요할 경우
                            <a
                                className="text-[#007aff] underline text-[clamp(14px,3vw,18px)]"
                                href="https://queenliveseller.channel.io/workflows/101063"
                                target="_blank"
                                rel="noreferrer"
                            >
                                고객센터(클릭)
                            </a>
                            로 문의해 주세요.
                        </span>
                    </p>
                </article>
                <article className="px-2 mb-5">
                    <img src={Modu} alt="" />
                </article>
                <Button
                    className="w-full h-[clamp(44px,3vw,52px)] text-[clamp(16px,3vw,20px)] "
                    onClick={() => navigator('/login')}
                >
                    잊지 않고 서명할게요
                </Button>
            </div>
        </section>
    )
}
